import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_SI.json';
import exercises from './FITNESS_EXERCISES_SI.json';
import recipes from './FITNESS_RECIPES_SI.json';

export const FITNESS_DATA_SI: ServiceData = {
  articles,
  exercises,
  recipes,
};
